import React from 'react'
import _Input from './Input/Input'
import { format } from 'd3-format'
export const Input = ({ onValueChange, ...props }) => {
  const onChange = (e) => {
    if (!onValueChange) {
      return
    }
    const v = e.target.value && e.target.value.replace(/[^-\d.]/g, '')
    const val = v && parseFloat(v) || ''
    onValueChange?.(val)
  }
  let value = (typeof props.value === 'string') ? props.value : ''
  if (typeof props.value === 'number') {
    value = `$${props.value}`
  }

  return (
    <_Input
      {...props}
      addonLeft='$'
      type='text'
      validRegExp={String.raw`(?:[-])?\$[\d]+(\.\d{2})?`}
      maskRegExp={String.raw`^(?:([-]))?(?:\$)?([\d]*)(?:(?:\.)?(\d{0,2}))?$`}
      maskReplacement='$1$$2.$3'
      onChange={onChange}
      value={value}
    />
  )
}

export const Output = props => {
  let data = (props.data ?? props.value) || 0
  return <span>{format(props.numberFormat || '$,')(data ? parseFloat(data).toFixed(2) : 0)}</span>
}
